import { useCallback } from 'react';

import { useRecoilState } from 'recoil';

import { sideBar } from '@recoil_iqfu/atoms/common/sidebar';

export type MenuToggleStateType = Record<
  'openPro' | 'openCsTool' | 'openIqfu' | 'openChat' | 'openLeaseback' | 'openDeal' | 'openJusetsu',
  boolean
>;

export const TargetMenu = {
  PRO: 'pro',
  CS_TOOL: 'csTool',
  IQFU: 'iqfu',
  CHAT: 'chat',
  LEASEBACK: 'leaseback',
  DEAL: 'deal',
  JUSETSU: 'jusetsu',
} as const;

export type TargetMenuValue = typeof TargetMenu[keyof typeof TargetMenu];

export const useMenuToggle = () => {
  const [iqfuMenuToggleState, setIqfuMenuToggleState] = useRecoilState(sideBar);
  const { openPro, openCsTool, openIqfu, openChat, openLeaseback, openDeal, openJusetsu } = iqfuMenuToggleState;
  const iqfuMenuToggleHandler = useCallback(
    (targetMenu: TargetMenuValue) => {
      switch (targetMenu) {
        case TargetMenu.PRO:
          setIqfuMenuToggleState((prev) => ({ ...prev, openPro: !openPro }));
          break;
        case TargetMenu.IQFU:
          setIqfuMenuToggleState((prev) => ({ ...prev, openIqfu: !openIqfu }));
          break;
        case TargetMenu.CS_TOOL:
          setIqfuMenuToggleState((prev) => ({ ...prev, openCsTool: !openCsTool }));
          break;
        case TargetMenu.CHAT:
          setIqfuMenuToggleState((prev) => ({ ...prev, openChat: !openChat }));
          break;
        case TargetMenu.LEASEBACK:
          setIqfuMenuToggleState((prev) => ({ ...prev, openLeaseback: !openLeaseback }));
          break;
        case TargetMenu.DEAL:
          setIqfuMenuToggleState((prev) => ({ ...prev, openDeal: !openDeal }));
          break;
        case TargetMenu.JUSETSU:
          setIqfuMenuToggleState((prev) => ({ ...prev, openJusetsu: !openJusetsu }));
          break;
        default:
          break;
      }
    },
    [iqfuMenuToggleState],
  );

  return { iqfuMenuToggleState, iqfuMenuToggleHandler };
};
